/*
  项目管理路由管理
  Date_: 2019-05-08 10:34:51 
*/
const routeMapper = [
  {
    path: '/login',
    name: 'login',
    component: () => import('../../../views/content/Login.vue')
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('../../../views/content/Home.vue'),
    children: [
      {
        path: '/',
        name: 'index',
        component: () => import('../../../views/content/Index.vue')
      },
      {
        path: 'teacher',
        name: 'teacherList',
        component: () => import('../../../views/content/TeacherList.vue')
      },
      {
        path: 'person',
        name: 'personList',
        component: () => import('../../../views/content/PersonList.vue')
      },
      {
        path: 'team',
        name: 'teamList',
        component: () => import('../../../views/content/TeamList.vue')
      },
      {
        path: 'work/person',
        name: 'workList',
        component: () => import('../../../views/content/WorkPersonList.vue')
      },
      {
        path: 'work/award',
        name: 'awardList',
        component: () => import('../../../views/content/AwardList.vue')
      },
      {
        path: 'award/view',
        name: 'awardView',
        component: () => import('../../../views/content/AwardView.vue')
      },
      {
        path: 'work/team',
        name: 'workList',
        component: () => import('../../../views/content/WorkTeamList.vue')
      },
      {
        path: 'view',
        name: 'viewList',
        component: () => import('../../../views/content/WorkJudge.vue')
      },
      {
        path: 'mine',
        name: 'viewList',
        component: () => import('../../../views/content/MyJudge.vue')
      },
      {
        path: 'test',
        name: 'viewList',
        component: () => import('../../../views/content/Test.vue')
      }
    ]
  }
]

export default routeMapper